import React, { useMemo } from "react";
import { Select } from "antd";

const getMetadataFields = (metadata) =>
    metadata.filter((el) => el.type === "number" || el.type === "score");

const getMetadataOptions = (metadataFields) =>
    metadataFields.map((field) => ({
        label: field.name,
        value: field.name,
        values: field.values,
    }));

export const NPSOverTimeFilter = ({
    selectedFieldDriverName,
    setSelectedFieldDriverName,
    metaData,
    widget,
    setDisplayName,
}) => {
    const metadataFields = useMemo(
        () =>
            getMetadataFields(
                metaData.metaData.filter(
                    (value) =>
                        value.values &&
                        value.values.length > 0 &&
                        value.values.length < 20
                )
            ),
        [metaData.metaData]
    );

    const metadataOptions = useMemo(
        () => getMetadataOptions(metadataFields),
        [metadataFields]
    );

    return (
        <Select
            showSearch
            style={{ width: 150 }}
            placeholder="Select Filter Driver Field"
            value={
                metadataOptions.some(
                    (option) => option.label === selectedFieldDriverName
                )
                    ? selectedFieldDriverName
                    : metadataOptions[0]?.label
            }
            onChange={(value) => {
                setSelectedFieldDriverName(value);
                setDisplayName(`${widget.text} ${value}`);
            }}
            options={metadataOptions}
            size="small"
        />
    );
};
